module.exports = __webpack_public_path__ + "static/img/1.0abe19d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/1.png
// module id = +kmW
// module chunks = 0